module.exports = __webpack_public_path__ + "img/tu_schedule_meeting.906137d9.svg";